import React from 'react';
import ReactECharts from 'echarts-for-react';

const MultiLineChart = (props) => {
  // Extraer todas las fechas únicas para usar como eje X
  const alldays = Array.from(
    new Set(props.data.flatMap(item => item.data.map(d => d.day)))
  );//.sort();

  // Construir series para ECharts
  const series = props.data.map(section => ({
    name: section.name,    
    smooth: true,
    type: 'line',
    label: {
      show: true,
      position: 'top', // Muestra encima de cada punto
      formatter: '{c}' // Muestra el valor
    },
    data: alldays.map(day => {
      const point = section.data.find(d => d.day === day);
      return point ? point.value : null;
    })
  }));

  const options = {
    title: {
      text: props.title || 'Título del gráfico',
      subtext: props.subTitle || '',
      left: 'center',
      top: 10
    },
    tooltip: {
      trigger: 'axis',
    },
    legend: {
      data: props.data.map(item => item.name),
      left: 'center',
      top: 'bottom' // Ajusta este valor según el espacio que deje el título
    },
    xAxis: {
      type: 'category',
      data: alldays
    },
    yAxis: {
      type: 'value',
      name: props.yLabel
    },
    series
  };

  return <ReactECharts
    option={options}
    notMerge={true} 
    style={{ height: '400px' }}
    ref={props.chartRef}
  />;
};

export default MultiLineChart;
